export const markdownConfig = {
  useHardBreaks: true,
  incrementOrderedListMark: false,
  defaultIndent: 2,
}
